// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"social-links_socialLinks__pB37Q","iconLink":"social-links_iconLink__UcGNz"};